import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3d12fee4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content-wrap" }
const _hoisted_2 = {
  key: 0,
  class: "loading-cover"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content-tips" }, " 需要放弃当前保单才能投保下一份意外机损保险，放弃当前保单需要进行投保人身份验证或提供企业/团体放弃保单申请书！ ", -1))
const _hoisted_4 = {
  key: 1,
  class: "verify-code"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "验证码", -1))
const _hoisted_6 = { class: "verify-tips" }

import { Loading } from 'vant'
import { useUsermobileInfo } from '@/compositions/common'
import { getInsuranceRefundInfo } from '@/apis/insurance'
import { ref, withDefaults, computed, Ref } from 'vue'
import JijiaVerifyCodeWrap from './jijia-verify-code-wrap.vue'
import PopupCommonWrap from '@/components/popup/common-wrap.vue'
import JijiaUploadApplcation from './jijia-upload-application.vue'
import CommonFooterNextButton from '@/components/CommonFooterNextButton.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'jijia-giveup-popup',
  props: {
    show: { type: Boolean, default: false },
    sn: { default: '' },
    needRefund: { type: Boolean, default: false }
  },
  emits: ['update:show', 'confirm'],
  setup(__props: any, { emit: emits }) {

const props = __props as { show: boolean, sn: string, needRefund: boolean };


const { userMobileComputed } = useUsermobileInfo()



const verifyCode = ref('')
const loading = ref(false)
const isPersonal = ref(false)
const fileUrl = ref('')
const popupStyle = {
  backgroundColor: 'white',
}
const confirmBtnStyle = {
  width: '200px',
  height: '40px',
}
let userPhone = ref('')
let policyNo = ref('')
const buttonDisabled = computed(() => {
  if (isPersonal.value) {
    return verifyCode.value.length !== 6
  } else {
    return fileUrl.value.length === 0
  }
})
const mobileLastFour = computed(() => {
  const value = userPhone.value
  if (!value) {
    return ''
  }
  return value.slice(-4)
})

function updateShowHandle(value: boolean) {
  emits('update:show', value)
}
function confirmHandle() {
  // console.log('22', 22)
  emits('confirm', {
    code: verifyCode.value,
    apply_file: fileUrl.value,
  })
}
async function initInsuranceDetail() {
  console.log('11', 11)
  loading.value = true
  try {
    const data = await getInsuranceRefundInfo({ sn: props.sn })
    userPhone.value = data.user_phone
    isPersonal.value = data.client_type === 1
    policyNo.value = data.policy_no
    // console.log('data', data)
  } catch (error) {
    console.log('error', error)
  }
  loading.value = false
}

if (props.needRefund) {
  initInsuranceDetail()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(PopupCommonWrap, {
    style: popupStyle,
    show: props.show,
    title: "放弃当前保单",
    "onUpdate:show": updateShowHandle
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (loading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_unref(Loading))
            ]))
          : _createCommentVNode("", true),
        _hoisted_3,
        (isPersonal.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _hoisted_5,
              _createVNode(JijiaVerifyCodeWrap, {
                code: verifyCode.value,
                "onUpdate:code": _cache[0] || (_cache[0] = ($event: any) => ((verifyCode).value = $event)),
                policyNo: _unref(policyNo)
              }, null, 8, ["code", "policyNo"]),
              _createElementVNode("div", _hoisted_6, " * 验证码会发送到投保账号的关联手机号 (尾号" + _toDisplayString(_unref(mobileLastFour)) + ") ", 1)
            ]))
          : (_openBlock(), _createBlock(JijiaUploadApplcation, {
              key: 2,
              fileUrl: fileUrl.value,
              "onUpdate:fileUrl": _cache[1] || (_cache[1] = ($event: any) => ((fileUrl).value = $event)),
              mode: "change"
            }, null, 8, ["fileUrl"])),
        _createVNode(CommonFooterNextButton, {
          title: "确定",
          disabled: _unref(buttonDisabled),
          btnStyle: confirmBtnStyle,
          onClick: confirmHandle
        }, null, 8, ["disabled"])
      ])
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})